import { supabase } from '../../shared/supabase/supabaseClient';
import { parseCatalogComboMetrics, type CatalogComboMetricsMap } from '../domain/comboMetrics';

export async function fetchCatalogComboMetrics(
  branchId: string,
  productIds: string[],
): Promise<CatalogComboMetricsMap> {
  const ids = productIds.filter((id) => id?.trim());
  if (!branchId?.trim() || ids.length === 0) return {};

  const { data, error } = await supabase.rpc('catalog_combo_metrics', {
    p_branch_id: branchId,
    p_product_ids: ids,
  });
  if (error) {
    console.warn('[catalog] catalog_combo_metrics', error.message);
    return {};
  }
  return parseCatalogComboMetrics(data);
}
